import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Archive } from "../../../@types/archive";
const deleteArchive = createAsyncThunk(
  "paymentNoticeDetail/deleteArchive",
  async (archiveId: string, { rejectWithValue }) => {
    try {
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(`${api.baseURL}archive/${archiveId}`, {
        method: "DELETE",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let archiveDeleted: Archive = await response.json();
      return archiveDeleted;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export default deleteArchive;
